import React from "react";
import { Text, View } from "react-native";

import moment from "moment";

import appStyles from "../../../appStyles";
import styles from "./integrationStyles";
import ManaMinutesDuration from "../../common/ManaMinutesDuration";
import { getBaseUrl } from "../../../../helpers/utils";

export default function IntegrationDetails({ details = [] }) {
  const getTime = (time) => {
    return moment(time).format("h:mma");
  };

  return (
    <View style={styles.detailsContainer}>
      {details.map((t, index2) => (
        <View key={index2} style={styles.row}>
          <View style={[styles.row, { flex: 1, marginRight: 8 }]}>
            <Text
              numberOfLines={1}
              title={t.name}
              style={[
                styles.tabName,
                { maxWidth: t.source?.url ? "50%" : "100%" },
              ]}
            >
              {t.name}
            </Text>

            {t.source?.url ? (
              <View style={[styles.row, { width: "50%" }]}>
                <Text style={styles.tabSeparator}>|</Text>
                <Text style={styles.tabName} numberOfLines={1}>
                  {getBaseUrl(t.source?.url)}
                </Text>
              </View>
            ) : null}
          </View>
          {/* Time interval */}
          <View
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "row",
            }}
          >
            {t.source?.startTime ? (
              <Text style={appStyles.captionThin}>
                {getTime(t.source?.startTime)}
              </Text>
            ) : null}
            {t.source?.duration ? (
              <>
                <Text style={[appStyles.captionThin, styles.pipe]}>|</Text>
                <ManaMinutesDuration
                  minutes={t.source?.duration}
                  style={appStyles.captionThin}
                />
              </>
            ) : null}
          </View>
        </View>
      ))}
    </View>
  );
}
